import React from "react"
import PropTypes from 'prop-types'
import Page from "../components/Page"
import data from '../data/speaker'

const SpeakerPage = ({ pageContext }) => {
  data.components[0].components[0].props.urls = pageContext.urls
  data.components[0].components[1].props = pageContext.speaker
  return (
    <>
      <Page
        name="speaker"
        language={pageContext.language}
        data={data}
      />
    </>
  )
}

SpeakerPage.propTypes = {
  pageContext: PropTypes.shape({
    language: PropTypes.string.isRequired,
    urls: PropTypes.array.isRequired,
    speaker: PropTypes.shape().isRequired,
  }),
}

export default SpeakerPage
